import { useCallback, useMemo } from "react";

import { convertPortfolioPlanToEntry } from "@fartherfinance/frontend/api/Investment/helpers/positionUtils";
import useGetPortfolioPlanByIdPublic from "@fartherfinance/frontend/api/Investment/hooks/useGetPortfolioPlanByIdPublic";
import {
  PortfolioPlanId,
  RequestConfig,
} from "@fartherfinance/frontend/api/Types";

export default (auth: RequestConfig | null) => {
  const useGetData = useCallback(
    (portfolioPlanId: PortfolioPlanId) => {
      const portfolioPlan = useGetPortfolioPlanByIdPublic(
        portfolioPlanId,
        {},
        auth
      );

      const entriesInPortfolioPlan = useMemo(() => {
        return convertPortfolioPlanToEntry(portfolioPlan.data) ?? [];
      }, [portfolioPlan]);

      return entriesInPortfolioPlan;
    },
    [auth]
  );
  return useGetData;
};
